// extracted by mini-css-extract-plugin
module.exports = {"block":"AboutIndustry_block__0bO0w","container":"AboutIndustry_container__t3gnB"};